export default __webpack_public_path__ + "static/media/actionsIcon.bdf83b14.svg";